// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 1100px){
    #title{
        font-size: 2em;
        margin-bottom: 30px;
    }

    #main-content{
        margin-top: 10px;
    }

    #form-title{
        font-size: 1.5em;
        font-weight: 650;
        margin-bottom: 25px;
    }

    .information-info{
        height: auto;
        width: 100%;
    }

    #information-container{
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 97%;
        height: auto;
        /*margin-left: 3%;*/
        margin-top: 10px;
    }

    .information-icon-container{
        width: 50px;
        height: 50px;
        margin-bottom: 3%;
    }

    .information-title{
        font-size: 1.3em;
    }

    .information-text{
        height: auto;
        word-wrap: break-word;
        font-size: 1em;
    }

    #location-pin-container{
        width: 40px;
        height: 50px;
    }

    #office-location-info{
        margin-top: 5px;
    }

    .form-component{
        margin-bottom: 3.5%;
    }

    .input-title{
        font-size: 1em;
    }

    .text-input{
        width: 77.8%;
        height: 20px;
        padding-left: 10px;
        font-size: 0.9em;
        border: 2px solid #e2e2e2;
        color: #012D26;
    }

    #needs{
        width: 70%;
        margin-left: 5%;
        /*border: 1px solid #D7ECE1;*/
    }

    .checkbox-container{
        display: flex;
        align-items: center;
        width: 100%;
        margin-top: 2%;
        /*border: 1px solid #D7ECE1;*/
    }

    .checkbox{
        font-size: 1em;
        width: 5%;
        height: 15px;
        margin-right: 3%;
    }

    .checkbox-description{
        height: 100%;
    }

    textarea{
        width: 75%;
        height: 100px;
        padding: 5px;
        border: 2px solid #ccc;
        font-size: 0.9em;
        font-family: raleway, sans-serif;
        resize: none;
    }

    .email-icon-container{
        width: 50px;
        height: 30px;
        margin-bottom: 10px;
    }
}

@media screen and (max-width: 600px){
    .information-text{
        height: auto;
        display: inline-block;
        word-wrap: break-word;
        font-size: 0.8em;
    }
}`, "",{"version":3,"sources":["webpack://./src/App/Page/Contact/contact-mobile.css"],"names":[],"mappings":"AAAA;IACI;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,UAAU;QACV,YAAY;QACZ,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,qBAAqB;QACrB,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,kBAAkB;QAClB,gBAAgB;QAChB,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,UAAU;QACV,eAAe;QACf,6BAA6B;IACjC;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,WAAW;QACX,cAAc;QACd,6BAA6B;IACjC;;IAEA;QACI,cAAc;QACd,SAAS;QACT,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,aAAa;QACb,YAAY;QACZ,sBAAsB;QACtB,gBAAgB;QAChB,gCAAgC;QAChC,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,qBAAqB;QACrB,qBAAqB;QACrB,gBAAgB;IACpB;AACJ","sourcesContent":["@media screen and (max-width: 1100px){\r\n    #title{\r\n        font-size: 2em;\r\n        margin-bottom: 30px;\r\n    }\r\n\r\n    #main-content{\r\n        margin-top: 10px;\r\n    }\r\n\r\n    #form-title{\r\n        font-size: 1.5em;\r\n        font-weight: 650;\r\n        margin-bottom: 25px;\r\n    }\r\n\r\n    .information-info{\r\n        height: auto;\r\n        width: 100%;\r\n    }\r\n\r\n    #information-container{\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: center;\r\n        width: 97%;\r\n        height: auto;\r\n        /*margin-left: 3%;*/\r\n        margin-top: 10px;\r\n    }\r\n\r\n    .information-icon-container{\r\n        width: 50px;\r\n        height: 50px;\r\n        margin-bottom: 3%;\r\n    }\r\n\r\n    .information-title{\r\n        font-size: 1.3em;\r\n    }\r\n\r\n    .information-text{\r\n        height: auto;\r\n        word-wrap: break-word;\r\n        font-size: 1em;\r\n    }\r\n\r\n    #location-pin-container{\r\n        width: 40px;\r\n        height: 50px;\r\n    }\r\n\r\n    #office-location-info{\r\n        margin-top: 5px;\r\n    }\r\n\r\n    .form-component{\r\n        margin-bottom: 3.5%;\r\n    }\r\n\r\n    .input-title{\r\n        font-size: 1em;\r\n    }\r\n\r\n    .text-input{\r\n        width: 77.8%;\r\n        height: 20px;\r\n        padding-left: 10px;\r\n        font-size: 0.9em;\r\n        border: 2px solid #e2e2e2;\r\n        color: #012D26;\r\n    }\r\n\r\n    #needs{\r\n        width: 70%;\r\n        margin-left: 5%;\r\n        /*border: 1px solid #D7ECE1;*/\r\n    }\r\n\r\n    .checkbox-container{\r\n        display: flex;\r\n        align-items: center;\r\n        width: 100%;\r\n        margin-top: 2%;\r\n        /*border: 1px solid #D7ECE1;*/\r\n    }\r\n\r\n    .checkbox{\r\n        font-size: 1em;\r\n        width: 5%;\r\n        height: 15px;\r\n        margin-right: 3%;\r\n    }\r\n\r\n    .checkbox-description{\r\n        height: 100%;\r\n    }\r\n\r\n    textarea{\r\n        width: 75%;\r\n        height: 100px;\r\n        padding: 5px;\r\n        border: 2px solid #ccc;\r\n        font-size: 0.9em;\r\n        font-family: raleway, sans-serif;\r\n        resize: none;\r\n    }\r\n\r\n    .email-icon-container{\r\n        width: 50px;\r\n        height: 30px;\r\n        margin-bottom: 10px;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 600px){\r\n    .information-text{\r\n        height: auto;\r\n        display: inline-block;\r\n        word-wrap: break-word;\r\n        font-size: 0.8em;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
